export const DEFAULT_SUPPORTED_PREVIEW_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
  "text/plain",
  "text/csv",
];

// Xem trước file đính kèm trong dialog
export const prepareDocumentPreview = async ({
  file,
  isRemote = false,
  downloadFn,
  onAlert,
  supportedTypes = DEFAULT_SUPPORTED_PREVIEW_TYPES,
}) => {
  try {
    let fileBlob;
    let fileName;
    let fileType;

    // FILE TỪ SERVER
    if (isRemote) {
      const fileId =
        file.id ||
        file.documentId ||
        file.personnelDocumentId;

      if (!fileId) {
        onAlert?.({
          open: true,
          severity: "error",
          message: "Không thể xem trước file này",
        });

        return null;
      }

      onAlert?.({
        open: true,
        severity: "info",
        message: "Đang tải file...",
      });

      const response = await downloadFn(fileId);

      fileBlob = response.data;

      fileName =
        file.documentName ||
        file.fileName ||
        "document";

      fileType =
        response.headers["content-type"] ||
        "application/octet-stream";
    }

    // FILE LOCAL
    else {
      fileBlob = file.file;
      fileName = file.file?.name || "document";
      fileType =
        file.file?.type ||
        "application/octet-stream";
    }

    // VALIDATE TYPE
    if (!supportedTypes.includes(fileType)) {
      onAlert?.({
        open: true,
        severity: "warning",
        message: `File ${fileName} không được hỗ trợ xem trước`,
      });

      return null;
    }

    // CREATE URL
    const url = URL.createObjectURL(fileBlob);

    onAlert?.({
      open: false,
    });

    return {
      open: true,
      file: url,
      fileName,
      fileType,
      fileBlob,
    };
  } catch (error) {
    console.error("Preview error:", error);

    onAlert?.({
      open: true,
      severity: "error",
      message: "Lỗi khi xem trước file",
    });

    return null;
  }
};

// Mở xem trước file đính kèm trong tab mới
export const openDocumentPreviewInNewTab = async ({
  file,
  isRemote = false,
  downloadFn,
  onAlert,
  supportedTypes = DEFAULT_SUPPORTED_PREVIEW_TYPES,
}) => {
  try {
    let fileBlob;
    let fileName;
    let fileType;

    if (isRemote) {
      const fileId =
        file.id ||
        file.documentId ||
        file.personnelDocumentId;

      if (!fileId) {
        onAlert?.({
          open: true,
          severity: "error",
          message: "Không thể xem trước file này",
        });
        return;
      }

      onAlert?.({
        open: true,
        severity: "info",
        message: "Đang tải file...",
      });

      const response = await downloadFn(fileId);

      fileBlob = response.data;
      fileName = file.documentName || file.fileName || "document";
      fileType =
        response.headers["content-type"] ||
        "application/octet-stream";
    } else {
      fileBlob = file.file;
      fileName = file.file?.name || "document";
      fileType =
        file.file?.type ||
        "application/octet-stream";
    }

    if (!supportedTypes.includes(fileType)) {
      onAlert?.({
        open: true,
        severity: "warning",
        message: `File ${fileName} không được hỗ trợ xem trước`,
      });
      return;
    }

    const blob =
      fileBlob instanceof Blob
        ? fileBlob
        : new Blob([fileBlob], { type: fileType });

    const previewUrl = URL.createObjectURL(blob);

    window.open(previewUrl, "_blank", "noopener,noreferrer");

    onAlert?.({ open: false });

    setTimeout(() => {
      URL.revokeObjectURL(previewUrl);
    }, 10000);
  } catch (error) {
    console.error("Preview error:", error);

    onAlert?.({
      open: true,
      severity: "error",
      message: "Lỗi khi xem trước file",
    });
  }
};